import React, { useState, useEffect } from 'react';
import { Surcharge, SurchargeCreate, SurchargeUpdate } from '../types/costwand.d';
import { Input } from './ui/input.tsx';
import { Button } from './ui/button.tsx';
import { Label } from '@radix-ui/react-label';
import { Spinner } from './ui/spinner.tsx'; // Import Spinner

interface SurchargeFormProps {
  initialData?: Surcharge | null;
  onSubmit: (data: SurchargeCreate | SurchargeUpdate) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
  // error?: string | null; // Removed error prop
}

const defaultFormData: SurchargeCreate = {
  description: '',
  code: 0,
  percentage: 0.0,
  created_by: 'tester',
};

const SurchargeForm: React.FC<SurchargeFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  isSubmitting = false,
  // error, // Removed error from destructuring
}) => {
  const [formData, setFormData] = useState<SurchargeCreate | SurchargeUpdate>(
    initialData
      ? {
          description: initialData.description,
          code: initialData.code,
          percentage: initialData.percentage,
          updated_by: initialData.updated_by || 'tester',
        }
      : defaultFormData
  );

  useEffect(() => {
    if (initialData) {
      setFormData({
        description: initialData.description,
        code: initialData.code,
        percentage: initialData.percentage,
        updated_by: initialData.updated_by || 'tester',
      });
    } else {
      setFormData(defaultFormData);
    }
  }, [initialData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value, type } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: type === 'number' ? parseFloat(value) || 0 : value,
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* {error && <p className="text-destructive text-sm">{error}</p>} */} {/* Removed local error display */}
      <div>
        <Label htmlFor="description" className="block text-sm font-medium text-foreground mb-1">Description</Label>
        <Input
          id="description"
          type="text"
          required
          value={formData.description || ''}
          onChange={handleChange}
          disabled={isSubmitting}
        />
      </div>
      <div>
        <Label htmlFor="code" className="block text-sm font-medium text-foreground mb-1">Code</Label>
        <Input
          id="code"
          type="number"
          required
          value={formData.code || ''}
          onChange={handleChange}
          disabled={isSubmitting}
        />
      </div>
      <div>
        <Label htmlFor="percentage" className="block text-sm font-medium text-foreground mb-1">Percentage</Label>
        <Input
          id="percentage"
          type="number"
          step="0.01"
          required
          value={formData.percentage || ''}
          onChange={handleChange}
          disabled={isSubmitting}
        />
      </div>
      <div className="flex justify-end gap-2">
        <Button type="submit" disabled={isSubmitting}>
          {isSubmitting ? <span className="flex items-center gap-2"><Spinner size="sm" /> Saving...</span> : 'Save'}
        </Button>
        <Button type="button" variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
      </div>
    </form>
  );
};

export default SurchargeForm;